module.exports = __webpack_public_path__ + "img/stake.99a595e4.svg";